import { render, staticRenderFns } from "./Supervisores.vue?vue&type=template&id=9cf6f378&lang=pug"
import script from "./Supervisores.vue?vue&type=script&lang=js"
export * from "./Supervisores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports